<template>
    <!-- copyright start -->
    <div class="pa-copyright">
        <div class="container">
            <p>
                <span class="mr-5">Copyright &copy; 2021 - now &nbsp; hello-get.com All rights reserved. </span>
                <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备2021009806号-1</a><span class="mr-5"> </span>
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602013773" rel="noreferrer" target="_blank"><img src="../assets/images/gongan-beian.png" style="width:14px;"> 浙公网安备33010602013773</a>
            </p>
        </div>
    </div>
    <!-- copyright end -->
</template>

<script>
export default {
  name: 'Copyright'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pa-copyright p{
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Copyright.vue